<template>
  <div class="pipeline-container">
    <div class="resource-bar-container"></div>
    <div class="simulator-container">
      <SimulatorTopBar ref="SimulatorTopBar" @pressedButton="$refs.CustomGantt.pressedButton($event)" />
      <ResourceBar ref="ResourceBar" @endedDrag="$refs.CustomGantt.endedDrag()" />
      <CustomGanttv2 ref="CustomGantt" />
    </div>
  </div>
</template>

<script>
import ResourceBar from "@/components/resourcebar/ResourceBar.vue";
import CustomGanttv2 from "@/components/CustomGanttv2.vue";
import SimulatorTopBar from "@/components/SimulatorTopBar.vue";
export default {
  name: "Pipeline",
  components: {
    ResourceBar,
    CustomGanttv2,
    SimulatorTopBar,
  },
  data() {
    return {
      dragging: false,
    };
  },
  mounted() {
  },
  methods: {},
};
</script>

<style scoped>
div {
  padding: 0;
  margin: 0;
}
.pipeline-container {
  padding: 0;
  margin: 0;
  height: 100%;

  display: flex;
  flex-direction: row;
}

.resource-bar-container {
  width: var(--resource-bar-width);
  display: flex;
  flex-direction: column;
}

.simulator-container {
  width: calc(100% - var(--sidebar-width));
  left: var(--sidebar-width);
  height: 100%;
  min-width: 400px;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  position: fixed;
}

.gant-chart-container {
  width: 100%;
  height: 100%; /*calc(100% - var(--simulation-button-height)); */
  /* padding-top: var(--simulation-button-height); */
}
</style>
